import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

type Payload = {
  proposalId: string
  deliveryDate?: string | null
  requestedDate?: string | null
  representantOrderNumber?: string
  expeditionObs?: string | null
  scienceStatus?: number | null
}

const sendSignedProposal = (data: Payload): Promise<unknown> => {
  return axios.put(`orders/${data.proposalId}/confirmations`, data)
}

export function useConfirmProposalData() {
  const queryClient = useQueryClient()
  return useMutation(sendSignedProposal, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      queryClient.invalidateQueries('loadConfirmProposalData')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível verificar orçamento!')
    }
  })
}
